<script>
import { usePrice } from '@phoenix/composables/price';

export default {
  props: {
    text: {
      type: [String, Number],
      default: '',
    },
    value: {
      type: Number,
      default: 0,
    },
    priceOnDemand: {
      type: Boolean,
      default: true,
    },
    currency: {
      type: String,
      default: '',
    },
    shouldDisplayFromPrice: {
      type: Boolean,
      default: false,
    },
    shouldDisplayCurrencyFirst: {
      type: Boolean,
      default: true,
    },
    vatInformation: {
      type: String,
      default: '',
    },
  },

  setup() {
    const { localizedPriceDisplayValue } = usePrice();

    return { localizedPriceDisplayValue };
  },

  computed: {
    displayedPrice() {
      return this.localizedPriceDisplayValue(
        {
          text: this.text,
          priceOnDemand: this.priceOnDemand,
          currency: this.currency,
          shouldDisplayCurrencyFirst: this.shouldDisplayCurrencyFirst,
        },
        this.shouldDisplayFromPrice,
        true,
      );
    },
  },
};
</script>
<template>
  <span v-html="displayedPrice" />
</template>
